import { ValuationsApproach } from 'common/types/valuation';
import { TERMINAL_VALUE_OPTIONS } from 'pages/Valuations/util/constants';
import { getApproachTableName } from 'pages/ValuationsAllocation/util';
import { TERMINAL_VALUE_CUSTOM_KEY, TVT_HM_TABLE_NAME, TVT_PG_TABLE_NAME } from './constants';

export const getTerminalGrowthCondition = (approach?: ValuationsApproach) => {
  const pg = getApproachTableName({ approach, tableSuffix: TVT_PG_TABLE_NAME });
  const hm = getApproachTableName({ approach, tableSuffix: TVT_HM_TABLE_NAME });
  // Selectors are synchronized across the five sheets; only the selected growth method constrains the result.
  return (
    `(compareText(${pg}.${TERMINAL_VALUE_CUSTOM_KEY}, "${TERMINAL_VALUE_OPTIONS.PERPETUITY_GROWTH}") != 0 or ${pg}.A3 > ${pg}.A4)` +
    ` and (compareText(${hm}.${TERMINAL_VALUE_CUSTOM_KEY}, "${TERMINAL_VALUE_OPTIONS.H_MODEL}") != 0 or ${hm}.A3 > ${hm}.A6)`
  );
};

export const guardTerminalGrowth = (expression: string, approach?: ValuationsApproach) =>
  `=IF(${getTerminalGrowthCondition(approach)}, ${expression.slice(1)}, null)`;
